/* Original product discovery navigation. Cart and drawer behavior stay independent. */
(() => {
  if (window.leDetoxShopMenu) return;
  window.leDetoxShopMenu = true;
  const desktop = matchMedia('(min-width: 1280px)');
  const isDesktop = menu => desktop.matches && menu.classList.contains('shop-menu--desktop');
  const timers = new WeakMap();
  const animations = new WeakMap();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  function syncVideo(panel, open) {
    panel.querySelectorAll('.shop-all-card__video').forEach(video => {
      if (open && !reducedMotion.matches) video.play().catch(() => {});
      else video.pause();
    });
  }
  function setOpen(menu, open) {
    clearTimeout(timers.get(menu));
    const toggle = menu.querySelector('[data-shop-toggle]');
    const panel = menu.querySelector('[data-shop-panel]');
    if (!toggle || !panel) return;
    if ((toggle.getAttribute('aria-expanded') === 'true') === open) return;
    const currentHeight = panel.getBoundingClientRect().height;
    animations.get(panel)?.cancel();
    panel.style.removeProperty('overflow');
    toggle.setAttribute('aria-expanded', String(open));
    panel.inert = !open;
    panel.hidden = false;
    syncVideo(panel, open);
    if (reducedMotion.matches || !panel.animate || (!open && currentHeight === 0)) {
      panel.hidden = !open;
      return;
    }
    const frames = isDesktop(menu)
      ? (open ? [{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'translateY(0)'}] : [{opacity:1},{opacity:0}])
      : [{height:`${currentHeight}px`,opacity:open ? 0 : 1},{height:open ? `${panel.scrollHeight}px` : '0px',opacity:open ? 1 : 0}];
    if (!isDesktop(menu)) panel.style.overflow = 'hidden';
    const animation = panel.animate(frames, {duration:open ? 240 : 180,easing:'cubic-bezier(.2,.65,.3,1)'});
    animations.set(panel, animation);
    animation.finished.then(() => {
      if (animations.get(panel) !== animation) return;
      panel.hidden = !open;
      panel.style.removeProperty('overflow');
      animations.delete(panel);
    }).catch(() => {}); // Rapid toggles cancel the prior transition deliberately.
  }
  const closeAll = () => document.querySelectorAll('[data-shop-menu]').forEach(menu => setOpen(menu, false));
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-shop-toggle]');
    if (toggle) {
      const menu = toggle.closest('[data-shop-menu]');
      setOpen(menu, toggle.getAttribute('aria-expanded') !== 'true');
      return;
    }
    if (!event.target.closest('[data-shop-menu]')) closeAll();
  });
  document.addEventListener('pointerover', event => {
    const menu = event.target.closest('[data-shop-menu]');
    if (!menu || !isDesktop(menu) || event.pointerType === 'touch') return;
    clearTimeout(timers.get(menu));
    // Reopen on entry, not while moving between children after an explicit close.
    if (!menu.contains(event.relatedTarget)) setOpen(menu, true);
  });
  document.addEventListener('pointerout', event => {
    const menu = event.target.closest('[data-shop-menu]');
    if (!menu || !isDesktop(menu) || menu.contains(event.relatedTarget)) return;
    // A short bridge across header padding allows deliberate pointer travel into the panel.
    timers.set(menu, setTimeout(() => {
      if (!menu.matches(':hover') && !menu.contains(document.activeElement)) setOpen(menu, false);
    }, 180));
  });
  document.addEventListener('focusin', event => {
    const menu = event.target.closest('[data-shop-menu]');
    // The SHOP link opens on focus; the adjacent toggle retains normal Enter/Space behavior.
    if (menu && isDesktop(menu) && event.target.matches('.shop-menu-link')) setOpen(menu, true);
  });
  document.addEventListener('focusout', event => {
    const menu = event.target.closest('[data-shop-menu]');
    if (menu && isDesktop(menu) && !menu.contains(event.relatedTarget)) setOpen(menu, false);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-shop-menu]') || document.querySelector('.shop-menu--desktop:has([aria-expanded="true"])');
    const toggle = menu?.querySelector('[data-shop-toggle][aria-expanded="true"]');
    if (!toggle) return;
    event.preventDefault();
    event.stopPropagation();
    setOpen(menu, false);
    toggle.focus({ preventScroll: true });
  });
  document.addEventListener('close', event => {
    if (event.target.matches('.menu-panel')) event.target.querySelectorAll('[data-shop-menu]').forEach(menu => setOpen(menu, false));
  }, true);
  desktop.addEventListener('change', closeAll);
  reducedMotion.addEventListener('change', () => {
    document.querySelectorAll('[data-shop-panel]').forEach(panel => syncVideo(panel, !panel.hidden && panel.closest('[data-shop-menu]').querySelector('[data-shop-toggle]').getAttribute('aria-expanded') === 'true'));
    if (reducedMotion.matches) document.querySelectorAll('[data-shop-panel]').forEach(panel => animations.get(panel)?.finish());
  });
})();
